import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 20,
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  title: {
    textAlign: "center",
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const EditSite = () => {
  const { siteId } = useParams();
  const classes = useStyles();

  const [formData, setFormData] = useState({
    site: [],
    dialPlans: [],
    voicePolicies: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      fetchWithToken("api/Sites/" + siteId),
      fetchWithToken("api/Forms"),
    ])
      .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
      .then(([siteData, formData]) =>
        setFormData({
          site: siteData,
          dialPlans: formData.dialPlans,
          voicePolicies: formData.voicePolicies,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm formData={formData} />
      )}
    </>
  );
};

const EditForm = ({ formData: formData }) => {
  const classes = useStyles();
  const history = useNavigate();

  const site = formData.site;
  const dialPlans = formData.dialPlans;
  const voicePolicies = formData.voicePolicies;

  const name = site.name;
  const country = site.country;
  const state = site.state;
  const city = site.city;
  const dialPlan = site.dialPlan;
  const voicePolicy = site.voicePolicy;
  const dnsSiteCode = site.dnsSiteCode;

  const [siteData, setSiteData] = useState({
    name: name,
    country: country,
    state: state,
    city: city,
    dialPlan: dialPlan,
    voicePolicy: voicePolicy,
    dnsSiteCode: dnsSiteCode,
  });

  const [submitData, setSubmitData] = useState(siteData);
  const [loading, setLoading] = useState(false);

  const myChangeHandler = (value, name) => {
    if (value === "") value = null;
    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      submitData.dialPlan === siteData.dialPlan &&
      submitData.voicePolicy === siteData.voicePolicy &&
      submitData.dnsSiteCode === siteData.dnsSiteCode
    ) {
      sendAlert(`No Changes Made`, "warning");
      return;
    }

    setSiteData((prev) => ({
      ...prev,
      dialPlan: submitData.dialPlan,
      voicePolicy: submitData.voicePolicy,
      dnsSiteCode: submitData.dnsSiteCode,
    }));

    setLoading(true);
    var success = false;

    fetchWithToken(`api/Sites/${site.id}`, "PUT", submitData)
      .then((res) => {
        if (res.ok) success = true;
        return res.json();
      })
      .then((data) => {
        sendAlert(data.returnMessage, success ? "success" : "error");
        setLoading(false);
        if (success) setSiteData({ ...submitData });
      });
  };

  const getDialPlans = () => {
    return dialPlans.map((plan) => {
      return { value: plan.value, label: plan.value };
    });
  };

  const getVoicePolicies = () => {
    return voicePolicies.map((policy) => {
      return { value: policy.value, label: policy.value };
    });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card
            className={classes.card}
            style={!alertMessage.active ? { marginTop: "68px" } : null}
          >
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <form onSubmit={submitHandler}>
                <Typography
                  sx={{ fontSize: 14 }}
                  style={{ margin: "20px", fontSize: "1.5em" }}
                  color="text.secondary"
                  gutterBottom
                >
                  Edit Site: {site.id}
                </Typography>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>Site Name:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.name}</h6>
                  </div>
                </div>
                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>Country:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.country}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>State:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.state}</h6>
                  </div>
                </div>
                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-3 col-form-label">
                    <h6>City:</h6>
                  </label>
                  <div class="col-sm-9" style={{ paddingTop: "8px" }}>
                    <h6>{site.city}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-3 col-form-label">
                    <h6>Dial Plan:</h6>
                  </label>
                  <div class="col-sm-9">
                    <Select
                      placeholder={""}
                      defaultValue={
                        siteData.dialPlan != null
                          ? {
                              value: siteData.dialPlan,
                              label: `${siteData.dialPlan}`,
                            }
                          : ""
                      }
                      options={getDialPlans()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "dialPlan"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="id" class="col-sm-3 col-form-label">
                    <h6>Voice Policy:</h6>
                  </label>
                  <div class="col-sm-9">
                    <Select
                      placeholder={""}
                      defaultValue={
                        siteData.voicePolicy != null
                          ? {
                              value: siteData.voicePolicy,
                              label: `${siteData.voicePolicy}`,
                            }
                          : ""
                      }
                      options={getVoicePolicies()}
                      onChange={(selection) => {
                        clearAlert();
                        myChangeHandler(
                          selection && selection.value ? selection.value : "",
                          "voicePolicy"
                        );
                      }}
                      menuPortalTarget={document.querySelector("body")}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="dnsSiteCode" class="col-sm-3 col-form-label">
                    <h6>DNS Site Code:</h6>
                  </label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      style={{ fontSize: "1em" }}
                      class="form-control"
                      name="dnsSiteCode"
                      maxlength="3"
                      defaultValue={site.dnsSiteCode}
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(e.target.value, "dnsSiteCode");
                      }}
                    />
                  </div>
                </div>
                {loading && (
                  <>
                    <div style={{ margin: "25px" }}>
                      <span style={{ display: "table", margin: "0 auto" }}>
                        Please Wait For Bulk Assign to Finish
                      </span>
                      <LinearProgress />
                    </div>
                  </>
                )}

                <div class="mb-3 row" style={{ margin: "20px" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.button}
                    color="primary"
                  >
                    Update
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => history("/site/manage")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditSite;
